<template>
	<v-tooltip bottom>
		<template v-slot:activator="{ on }">
			<span v-if="date != null && showDate" v-on="on" :class="textClass">{{ date | formatDate(format) }}</span>
			<span v-else-if="date != null" v-on="on" :class="textClass">{{ date | diffForHumans }}</span>
			<span v-else :class="textClass">{{ nullDate }}</span>
		</template>
		<span>{{ tooltip }}</span>
	</v-tooltip>
</template>

<script>
	import moment from 'moment';

	export default {
		props: {
			date: {
				required: true
			},
			nullDate: {
				type: String
			},
			showDate: {
				type: Boolean
			},
			showTitle: {
				type: Boolean,
				default: true
			},
			prependTooltip: {
				type: String,
				default: null
			},
			format: {
				type: String,
				default: 'Do MMM YYYY'
			},
			textClass: {
				type: String,
				default: ''
			}
		},
		filters: {
			humanFriendlyDate(date) {
				return moment(date).format('MMMM Do YYYY');
			},
			diffForHumans(date) {
				return moment(date).fromNow();
			}
		},
		computed: {
			tooltip() {
				if (this.date != null && this.showDate) {
					return this.prependTooltip ? `${this.prependTooltip} ${this.$options.filters.diffForHumans(this.date)}` : this.$options.filters.diffForHumans(this.date);
				} else if (this.date != null) {
					return this.prependTooltip ? `${this.prependTooltip} ${this.$options.filters.humanFriendlyDate(this.date)}` : this.$options.filters.humanFriendlyDate(this.date);
				}
				return null;
			}
		}
	};
</script>

<style></style>
